<template>
  <div class="tab-pane fade show active" role="tabpanel">
    <div class="card">
      <div class="card-body">
        <InventoryManagementComponent
          v-if="company.id"
          :company-id="company.id"
          :company="company"
          :is_admin="isAdmin"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import InventoryManagementComponent from "@/dashboard/inventory_management/InventoryManagementComponent.vue";
import type { Company } from "@/types";

defineProps<{
  company: Company;
  isAdmin: boolean;
}>();
</script>
